export const routesConfig = {
  app: "/app",
  orders: "/app/orders",
  createOrder: "/app/orders/create",
  updateOrder: "/app/orders/update/",
  enRouteOrder: "/app/orders/en-route",
  enRouteViewer: "/app/orders/en-route-viewer",
  readyForTakeOffViewer: "/app/orders/ready-for-take-off-viewer",
  takeOffToEnRoute: "/app/orders/take-off-to-en-route",

  createMission: "/app/orders/create-mission",
  confirmOrder: "/app/orders/confirm-order",
  checklistOrder: "/app/orders/checklist",
  
  readyForTakeOff: "/app/orders/ready-for-take-off",

  assignDrone: "/app/orders/assign-drone",
  modifyDrone: "/app/orders/modify-route",

  drones: "/app/drones",
  fleet: "/app/fleet",
  addDrone: "/app/fleet/add-drone",

  viewer: "/app/viewer",
  profile: "/app/profile",
  settings: "/app/settings",
  settingsController: "/app/settings/controller",
  history: "/app/history",
  zones: "/app/zones",
  createZone: "/app/zones/create",
  editZone: "/app/zones/edit",
  checklist: "/app/checklist",
  integration: "/app/integration",
  analytics: "/app/analytics",
  
  auth: "/auth",
  signIn: "/auth/signIn",
  signUp: "/auth/signUp",
  agreement: "/auth/agreement",
  activate: "/auth/activate",
  verifyEmail: "/auth/verify-email",
  verifySuccess: "/auth/verify-success",
  resetPassword: "/auth/reset-password",
};
